import { render } from "./BarrocoPedanias.vue?vue&type=template&id=2c0ed6c3"
import script from "./BarrocoPedanias.vue?vue&type=script&lang=js"
export * from "./BarrocoPedanias.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__